<div *ngIf="axe5">
    <page-header [title]="(isCreation ? 'admin.entreprise.analytique.axe5.infos.title' : 'admin.entreprise.analytique.axe5.infos.titleModification') | translate : { reference: axe5.reference }"
        [listeItems]="listeTabItems"
        (onSelectedItemChange)="onSelectedItemChange($event)" (onGoBack)="onGoBack()">
    </page-header>

    <form #form="ngForm">
        <div [hidden]="selectedItem?.code !== Onglet.REFERENTIEL1">
            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.entreprise.analytique.axe5.infos.ajoutCodeProjet'">
                    </span>
                </mat-card-title>
                <mat-card-content>
                    <fieldset>
                        <div class="row" *ngIf="axe5.actif != null">
                            <custom-input ngDefaultControl
                                            id="libelle"
                                            name="libelle"
                                            [(ngModel)]="axe5.libelle"
                                            customType="input"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.libelle"
                                            [required]="true"></custom-input>
                            <custom-input ngDefaultControl
                                            id="isActif"
                                            name="isActif"
                                            [ngModel]="axe5.actif"
                                            [(customModel)]="axe5.actif"
                                            customType="checkbox"
                                            lCol="4"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.actif"></custom-input>
                        </div>
                        <div class="row">
                            <custom-input ngDefaultControl
                                            id="reference"
                                            name="reference"
                                            [(ngModel)]="axe5.reference"
                                            customType="input"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.reference"
                                            [required]="true"></custom-input>
                            <custom-input ngDefaultControl
                                            id="dateDebut"
                                            name="dateDebut"
                                            [ngModel]="axe5.dateDebut"
                                            [(customModel)]="axe5.dateDebut"
                                            customType="date"
                                            lCol="4"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.dateDebut"></custom-input>
                        </div>
                        <div class="row">
                            <custom-input ngDefaultControl
                                            id="code1"
                                            name="code1"
                                            [(ngModel)]="axe5.code1"
                                            customType="input"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.code1"></custom-input>
                            <custom-input ngDefaultControl
                                            id="dateFin"
                                            name="dateFin"
                                            [ngModel]="axe5.dateFin"
                                            [(customModel)]="axe5.dateFin"
                                            [dateMin]="axe5.dateDebut"
                                            customType="date"
                                            lCol="4"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.dateFin"></custom-input>
                        </div>
                        <div class="row">
                            <custom-input ngDefaultControl
                                            id="code2"
                                            name="code2"
                                            [(ngModel)]="axe5.code2"
                                            customType="input"
                                            rCol="2"
                                            libelle="admin.entreprise.analytique.axe5.infos.code2"></custom-input>
                        </div>
                    </fieldset>
                </mat-card-content>
            </mat-card>
            <mat-card>
                <mat-card-title>
                    <span [translate]="'admin.entreprise.analytique.axe5.infos.filtres'"></span>
                    <span class="actions clickable">
                        <mat-icon (click)="addFiltre()">add</mat-icon>
                    </span>
                </mat-card-title>
                <mat-card-content>
                    <div class="listview">
                        <div class="listview-body">
                            <div class="empty" *ngIf="listeFiltre.length === 0 else filtres">
                                <span [translate]="'admin.entreprise.analytique.axe5.infos.filtre.noData'"></span>
                            </div>
                            <ng-template #filtres>
                                <div class="listview-item" *ngFor="let filtre of listeFiltre">
                                    <div class="lvi-content">
                                        <div class="avatar" [ngSwitch]="filtre.type">
                                            <span *ngSwitchCase="1">{{ filtreTypes.SE }}</span>
                                            <span *ngSwitchCase="2">{{ filtreTypes.CC }}</span>
                                            <span *ngSwitchCase="9">{{ filtreTypes.TE }}</span>
                                            <span *ngSwitchDefault>{{ filtreTypes.MC }}</span>
                                        </div>
                                        <div class="lvi-body">
                                            <div class="title">
                                                <a class="label">{{ filtre.libelle }}</a>
                                            </div>
                                            <ul class="lvi-attrs">
                                                <li [ngSwitch]="filtre.type">
                                                    <strong [translate]="'admin.entreprise.analytique.axe5.infos.type'"></strong>
                                                    <span *ngSwitchCase="1" [translate]="'admin.entreprise.analytique.axe5.infos.filtre.se'"></span>
                                                    <span *ngSwitchCase="2" [translate]="'admin.entreprise.analytique.axe5.infos.filtre.cc'"></span>
                                                    <span *ngSwitchCase="9" [translate]="'admin.entreprise.analytique.axe5.infos.filtre.te'"></span>
                                                    <span *ngSwitchDefault [translate]="'admin.entreprise.analytique.axe5.infos.filtre.mc'"></span>
                                                </li>
                                            </ul>
                                        </div>
                                        <div class="lvi-actions">
                                            <button mat-icon-button [matMenuTriggerFor]="listeActions">
                                                <mat-icon>more_vert</mat-icon>
                                            </button>
                                            <mat-menu #listeActions="matMenu">
                                                <button mat-menu-item (click)="deleteFiltre(filtre)" translate="global.actions.supprimer"></button>
                                            </mat-menu>
                                        </div>
                                    </div>
                                </div>
                            </ng-template>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </form>
</div>
<floating-button [listeActions]="listeActions" [isPending]="isSaving"></floating-button>